/**
 * Identità del poligono: denominazione e logo.
 *
 * Questo è l'unico posto in cui il marchio è scritto. Lo importano sia il client sia le
 * funzioni del server (`functions/` può importare da `src/lib/`, come già fa per le
 * password), così denominazione e logo non possono divergere fra schermate, PDF e API.
 *
 * ── Il logo è codice, non dato ──────────────────────────────────────────────────────
 * Sta in `public/` e viaggia con la distribuzione. Non è caricabile né modificabile
 * dall'applicazione: cambiarlo significa sostituire il file qui accanto e distribuire.
 * È una scelta deliberata, per due ragioni.
 *
 * 1. Le schermate di accesso (6a–6c) mostrano il logo prima che esista una sessione. Una
 *    risorsa statica servita da Pages non chiede autenticazione; un oggetto su R2 sì, e
 *    infatti da lì il logo non si sarebbe mai potuto vedere sulla schermata di accesso.
 * 2. Toglie a R2 un compito che non gli serve: là restano firme e documenti, che sono
 *    dati personali e devono stare protetti. Il marchio non lo è.
 *
 * ── La denominazione è dato ─────────────────────────────────────────────────────────
 * Resta in `configurazione` perché la § 8 la stampa sui documenti insieme a indirizzo,
 * partita IVA e Questura, e perché il mockup 9b prevede il campo. Il valore qui sotto è
 * il ripiego che evita il lampo di testo generico prima che l'API risponda, ed è lo
 * stesso che la migrazione 0006 semina nel database.
 */

/** Denominazione del poligono. Allineata alla migrazione 0006. */
export const DENOMINAZIONE = 'Zevio Sporting Club - Viking Training';

/**
 * Logo mostrato nelle testate e nelle schermate di accesso.
 *
 * Nelle testate ce ne sta uno solo: sono alte fra i 34 e i 44 px e due marchi affiancati
 * diventerebbero due macchie indistinguibili. Sul foglio credenziali, dove lo spazio c'è,
 * compaiono entrambi.
 */
export const LOGO = '/logo.jpg';

/** Il secondo marchio. Compare sui documenti stampati, accanto al primo. */
const LOGO_VIKING = '/logo-viking.jpg';

/** I due marchi nell'ordine in cui vanno letti, per l'intestazione dei documenti (§ 8). */
export const LOGHI = [LOGO, LOGO_VIKING] as const;
